const UserList = () => import('./pages/index')
const UserNew = () => import('./pages/new')
const UserEdit = () => import('./pages/edit')

export default [
  {
    path: '/users',
    name: 'user.index',
    component: UserList,
    meta: { requiresAuth: true }
  },
  {
    path: '/users/new',
    name: 'user.new',
    component: UserNew,
    meta: {
      requiresAuth: true,
      permissions: ['user']
    }
  },
  {
    path: '/users/edit/:id',
    name: 'user.edit',
    component: UserEdit,
    meta: { requiresAuth: true }
  }
]



// WEBPACK FOOTER //
// ./src/features/user/routes.js